const SHOW = 'SHOW';
const HIDE = 'HIDE';

const state = {
    show: false,
    x: 'left',
    y: 'bottom',
    timeout: 4000,
    mode: null,
    color: null,
    text: '',
};

const actions = {
    /**
     * Show snackbar.
     * @param {function} commit
     * @param {object} data
     */
    show({ commit }, data) {
        commit(SHOW, data);
    },

    /**
     * Hide snackbar.
     * @param {function} commit
     */
    hide({ commit }) {
        commit(HIDE);
    },
    /**
     * Show message.
     * @param {function} commit
     * @param {string} message
     */
    showMessage({ commit }, message) {
        const data = {
            text: message,
            color: 'primary',
        };

        commit(SHOW, data);
    },

    /**
     * Show message.
     * @param {function} commit
     * @param {string} message
     */
    showWarningMessage({ commit }, message) {
        const data = {
            text: message,
            color: 'secondary',
        };

        commit(SHOW, data);
    },
};

const mutations = {
    [SHOW](state, data) {
        state.text = data.text;
        state.color = data.type;

        if (data.color) {
            state.color = data.color;
        }

        if (!data.text) {
            state.text = 'Something went wrong.';
        }

        state.show = true;
    },
    [HIDE](state) {
        state.show = false;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
